export class TableEventPayload {
  tableName: string;
  eventName: string;
  id: string;
  formContext?: string;
  data: any;
  tableOperation?: any;

  static getTopic = (tableName: string, eventName: TableEvent) => `${tableName}.${eventName}`
}

export type TableEvent = TableUpdateEvent | TableCreateEvent | TableSyncEvent |string;
export type TableUpdateEvent = 'update'
export type TableCreateEvent = 'create'
export type TableSyncEvent = 'sync'
